import { Box, Text, Wrap } from '@chakra-ui/react';
import Skill from './Skill';
import { scrubSelected } from '../utils';

const SkillsBox = ({ props, qObj, selectedSkills, style }) => {
  const scrubbedSelected = scrubSelected(props,selectedSkills);
  return (
    <Box pt={4}>
      <Box sx={{ ...style.skillsBox.mainBox }}>
        <Text sx={{ ...style.skillsBox.mainBox.text }}></Text>
        <Wrap sx={{ ...style.skillsBox.mainBox.wrap }} justify='center' id='selectedSkills'>
          {scrubbedSelected.map((skill, i) => {
            return (
              <Skill props={props} qObj={qObj} skill={skill} style={style} />
            );
          })}
        </Wrap>
      </Box>
    </Box>
  );
};
export default SkillsBox;
